import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-tooltip/dist/react-tooltip.css";
import "katex/dist/katex.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import UserContextProvider from "./context/UserContextProvider";
import AppContextProvider from "./context/AppContextProvider";
import BaseRouterProvider from "./router/BaseRouterProvider";
import Modal from "react-modal";
import { GoogleOAuthProvider } from "@react-oauth/google";
import AppErrorBoundary from "./components/common/error/AppErrorBoundary";

// chart.js registration lives in utilization/ChartSetup (imported by the chart consumers) and the
// react-pdf worker/CSS setup in library/components/pdfs/BasePDF — keeping both out of this entry
// file so the chart/PDF stacks land in their consumers' lazy chunks instead of the main bundle.

const root = ReactDOM.createRoot(document.getElementById("root"));
Modal.setAppElement("#root");

root.render(
  // <React.StrictMode>
  <AppErrorBoundary>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <AppContextProvider>
        <UserContextProvider>
          <App>
            <div className="appr-root">
              {/* {process.env.REACT_APP_NODE_ENV === "local" ||
              process.env.REACT_APP_NODE_ENV === "development" ? (
                <div className="appr-env-banner">
                  <p>{process.env.REACT_APP_NODE_ENV}</p>
                </div>
              ) : null} */}
              <BaseRouterProvider />
            </div>
          </App>
        </UserContextProvider>
      </AppContextProvider>
    </GoogleOAuthProvider>
  </AppErrorBoundary>,
  // </React.StrictMode>
);

reportWebVitals();
